import { getSupabase } from '../../lib/supabase'
import { createSupabaseSource } from './supabaseSource'

export * from './memorySource'
export * from './summarise'
export * from './supabaseSource'
export * from './types'

/** The app's source: the bombeo Supabase project of the current build. */
export const scalesSource = createSupabaseSource(getSupabase)
export * from './gantt'
